import { formatMoney } from "@/functions/helpers";
import { Line } from "vue-chartjs";
import moment from "moment";

export default {
  extends: Line,
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      options: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enable: true,
          backgroundColor: "#fcfcfc",
          titleFontColor: "#000",
          borderColor: "rgba(0, 0, 0, 0.2)",
          bodyFontColor: "#000",
          borderWidth: 1,
          callbacks: {
            title: function(item) {
              return moment(item[0].label, "DD/MM/YYYY").format(
                "DD [de] MMMM YYYY"
              );
            },
            label: function(item) {
              return `R$ ${formatMoney(item.yLabel)}`;
            }
          }
        },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "#928F98",
                fontSize: 12,
                padding: 15,
                callback: function(value) {
                  return moment(value, "DD/MM/YYYY").format("DD/MM");
                }
              },
              gridLines: {
                display: false,
                drawTicks: false,
                offsetGridLines: false
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                maxTicksLimit: 5,
                beginAtZero: true,
                fontColor: "#928F98",
                drawOnChartArea: true,
                callback: function(value) {
                  if (Math.abs(value) <= 999) {
                    return Math.abs(value);
                  }

                  if (Math.abs(value) < 1000000) {
                    return (
                      Math.sign(value) * (Math.abs(value) / 1000).toFixed(1) +
                      " k  "
                    );
                  }

                  if (Math.abs(value) <= 1000000000) {
                    return (
                      Math.sign(value) *
                        (Math.abs(value) / 1000000).toFixed(1) +
                      " mi  "
                    );
                  }

                  if (Math.abs(value) <= 1000000000000) {
                    return (
                      Math.sign(value) *
                        (Math.abs(value) / 1000000000).toFixed(1) +
                      " bi  "
                    );
                  }

                  if (Math.abs(value) <= 1000000000000000) {
                    return (
                      Math.sign(value) *
                        (Math.abs(value) / 1000000000000).toFixed(1) +
                      " ti  "
                    );
                  }

                  if (Math.abs(value) <= 1000000000000000000) {
                    return (
                      Math.sign(value) *
                        (Math.abs(value) / 1000000000000000).toFixed(1) +
                      " qi  "
                    );
                  }

                  return value;
                }
              },
              gridLines: {
                display: false,
                drawTicks: true
              }
            }
          ]
        }
      }
    };
  },
  watch: {
    data(updateDt) {
      this.renderChart(updateDt, this.options);
    }
  },
  mounted() {
    this.renderChart(this.data, this.options);
  }
};
